import { useEffect, useState } from 'react'

import Link from 'next/link'

import {
	CommentSection,
	DotContainer,
	DesktopCommentsCards,
	CommentTextDesktop,
	TextLink,
	Dot
} from './styles'

import { getPreviewEvaluations } from 'services/evaluation'

import { Row } from 'components/v2/Grid'
import { StarFilled } from 'components/v2/Icons/assets/StarFilled'
import { Text } from 'components/v2/Text'

import { checkIsMobile } from 'utils/helpers'

const fiveStarsDesk = Array(5).fill(<StarFilled height='22px' width='24px' />)

const MAX_PAGES = 6
const SHOW_PER_PAGE_DESKTOP = 3
const SHOW_PER_PAGE_MOBILE = 1

const anonymizePatientName = (fullName) => {
	const [firstName, ...otherNames] = fullName
		.trim()
		.split(/\s+/)
		.filter(Boolean)

	if (!otherNames.length) return firstName

	const lastName = otherNames[otherNames.length - 1]
	return `${firstName} ${lastName.charAt(0).toUpperCase()}.`
}

const arrayGroup = (array, subGroupLength) => {
	let index = 0
	const newArray = []

	while (index < array.length) {
		newArray.push(array.slice(index, (index += subGroupLength)))
	}

	return newArray
}

const KnowMore = () => {
	const [comments, setComments] = useState([])
	const [page, setPage] = useState(1)
	const [totalPages, setTotalPages] = useState(0)
	const isMobile = checkIsMobile(993)

	const SHOW_PER_PAGE = isMobile ? SHOW_PER_PAGE_MOBILE : SHOW_PER_PAGE_DESKTOP

	useEffect(() => {
		;(async () => {
			try {
				const { data } = await getPreviewEvaluations({
					per_page: 6,
					min_stars: 5,
					page
				})
				setComments(arrayGroup(data.results, SHOW_PER_PAGE)[page - 1])
				setTotalPages(
					MAX_PAGES > Math.ceil(data.results.length / SHOW_PER_PAGE)
						? Math.ceil(data.results.length / SHOW_PER_PAGE)
						: MAX_PAGES
				)
			} catch (error) {
				console.log(error)
			}
		})()
	}, [page])

	const handlePageChange = (page) => {
		setPage(page)
	}

	return (
		<CommentSection className='py-8'>
			<Text
				as='h2'
				className='mb-4 text-2xl font-medium text-gray-800 md:text-3xl'
			>
				E quem já faz terapia?
			</Text>
			<Text className='mb-1 text-base font-medium text-gray-800 md:text-2xl'>
				Confira os comentários de pacientes que já passaram por atendimento
				psicológico online na Vittude. Relatos reais ajudam a entender como a
				experiência acontece na prática e reforçam a importância do vínculo
				terapêutico.
			</Text>
			<Row className='mt-8 md:mt-16'>
				{comments?.map(({ comment, consultation, id }) => (
					<DesktopCommentsCards key={`comment-${id}`}>
						<Row>
							<CommentTextDesktop className='h-[140px]'>
								<Text className='font-medium leading-6'>{`"${comment}"`}</Text>
							</CommentTextDesktop>
						</Row>
						<Row className='mb-[14px] mt-[10px]'>
							{fiveStarsDesk.map((star) => star)}
						</Row>
						{consultation.patient?.name && (
							<Text className='mb-2 font-bold text-blue-900'>
								{anonymizePatientName(consultation.patient.name)}
							</Text>
						)}
						<Text className='mb-4 text-blue-900'>
							Paciente de{' '}
							<Link
								href={`/psicologo/${consultation.professional.slug}`}
								legacyBehavior
							>
								<TextLink>{consultation.professional.name}</TextLink>
							</Link>
						</Text>
					</DesktopCommentsCards>
				))}
			</Row>
			<DotContainer>
				{Array(totalPages)
					.fill(0)
					.map((_, index) => (
						<Dot
							key={`dot-${index}`}
							onClick={() => handlePageChange(index + 1)}
							active={page === index + 1}
						/>
					))}
			</DotContainer>
		</CommentSection>
	)
}

export default KnowMore
